// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1bCEF","label":"Radio_label__1vmDL","checkMark":"Radio_checkMark__2qhPj","disabled":"Radio_disabled__3eTQN"};